import './index.css';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { importBuildTarget } from './projects';

if (!Object.hasOwn) {
  Object.hasOwn = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

const { default: Environment } = await importBuildTarget(
  process.env.REACT_APP_NAME,
  process.env.REACT_APP_BUILD_TARGET
);

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <Environment />);
} else {
  createRoot(rootElement).render(<Environment />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

